import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_MAIN = "https://customer-assets.emergentagent.com/job_ce22ad00-db82-461a-af39-4177f369e9d1/artifacts/wsj2zzd9_ETHIDA%202%20BLACK%20Mittel.png";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#020408] text-white">
      <div className="container mx-auto px-5 py-12 max-w-3xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <Link to="/" className="flex items-center gap-2 text-[#a3e635] hover:text-[#22d3ee] transition-colors" data-testid="back-to-home">
            <ArrowLeft size={20} />
            <span className="text-sm font-medium">Zurück zur Startseite</span>
          </Link>
          <img src={LOGO_MAIN} alt="ENTHIDA Logo" className="h-8 opacity-60" />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-8" data-testid="impressum-title">Impressum</h1>

        <div className="space-y-8 text-slate-300 leading-relaxed">
          {/* Angaben gemäß § 5 TMG */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">Angaben gemäß § 5 TMG</h2>
            <p>
              ENTHIDA – Smart Energy Systems<br />
              Inh. Enes Dedic<br />
              Elektromeisterbetrieb
            </p>
            <p className="mt-3">
              Ludwig-Stempfl-Str. 17<br />
              84307 Eggenfelden
            </p>
          </section>

          {/* Kontakt */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">Kontakt</h2>
            <p>
              Telefon: +49 176 41234 614<br />
              E-Mail: info@enthida.de<br />
              Web: www.enthida.de
            </p>
          </section>

          {/* Umsatzsteuer-ID */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              USt-IdNr.: DE462189160
            </p>
            <p className="mt-2">
              Steuernummer: 113/210/40669
            </p>
          </section>

          {/* Berufsbezeichnung */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
            <p>
              Berufsbezeichnung: Elektromeister<br />
              Zuständige Kammer: Handwerkskammer Niederbayern-Oberpfalz (HWK Niederbayern)<br />
              Betriebsnummer: 85211<br />
              Verliehen in: Deutschland
            </p>
            <p className="mt-2">
              Eintragung in die Handwerksrolle bei der HWK Niederbayern-Oberpfalz
            </p>
          </section>

          {/* Streitschlichtung */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#22d3ee] hover:underline">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-2">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          {/* Haftung für Inhalte */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
              unter der Pflicht, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
              zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-2">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
              Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          {/* Haftung für Links */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          {/* Urheberrecht */}
          <section>
            <h2 className="text-xl font-bold text-white mb-3">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-6 border-t border-white/10 text-center">
          <Link to="/" className="text-[#a3e635] hover:text-[#22d3ee] transition-colors text-sm font-medium">
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
